import {FLIGHT_SEARCH_LIST, FLIGHT_MANIFEST_BOARDING, FLIGHT_TRIP_BOARDING, SET_SELECTED_FLIGHT_LEGKEY, ASSIST_QUEUE, SEAT_MAP_TASK, AISLE, WINDOW } from './FlightSearchType';

const initialState={
    flightList: [],
    flightManifestBoarding: null,
    flightTripBoarding: null,
    selectedFlight: null,
    assistQueue: [],
    seatmapTask: 'ASSIGNSEAT',
    seatPreferenceAisle: false,
    seatPreferenceWindow: false
}

const flightSearchReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        case FLIGHT_SEARCH_LIST: return{
            ...state,
            flightList: action.flightList
        }
        case FLIGHT_MANIFEST_BOARDING: return{
            ...state,
            flightManifestBoarding: action.flightManifestBoarding
        }
        case FLIGHT_TRIP_BOARDING: return{
            ...state,
            flightTripBoarding: action.flightTripBoarding
        }
        case SET_SELECTED_FLIGHT_LEGKEY: return {
            ...state,
            selectedFlight: action.selectedFlight
        }
        case ASSIST_QUEUE: return {
            ...state,
            assistQueue: action.assistQueue
        }
        case SEAT_MAP_TASK: return {
            ...state,
            seatmapTask: action.seatmapTask
        }
        case AISLE: return {
            ...state,
            seatPreferenceAisle: action.seatPreferenceAisle
        }
        case WINDOW: return {
            ...state,
            seatPreferenceWindow: action.seatPreferenceWindow
        }
        default: return state
    }
}

export default flightSearchReducer;